import {
 Text,
 Flex,
 Box,
 Stack,
 Button,
 RadioGroup,
 Radio,
 Checkbox,
} from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { QuestionHelper } from '../Data';
import RotuloClassificacao from '../Catalog/RotuloClassificacao';
import MedidasGri from '../Catalog/MedidasGri';
import FeedbackChatReviewerPopover from '../Feedback/Chat-reviewer';
import { CustomCheckbox, InputText } from '../Input';
import { NumericFormat } from 'react-number-format';

const QuestionCardReviewer = React.memo(
 ({
  question,
  handleQuestionEvidence,
  surveyId,
  mutate,
  userId,
  questionnaireType,
  themeId,
 }) => {
  const { code, description, type, helper } = question;

  const questionOptions = useMemo(() => {
   return question?.options
    ? question?.options
    : question?.question_option_template
    ? question?.question_option_template
    : [];
  }, [question]);

  const response = question?.users_responses
    ? Array.isArray(question?.users_responses)
      ? question.users_responses[0]
      : question.users_responses
    : null;

  const selectedOptions = useMemo(() => {
   if (response && (type === 'multiple_choice' || type === 'multi_choice')) {
    const responseValue = response?.response;
    let responseParts = [];
    let canBeOld = false;

    if (responseValue?.includes('||')) {
     responseParts = responseValue?.split('||').map((part) => part.trim());
    } else if (responseValue?.includes(',') && !responseValue?.includes('||')) {
     canBeOld = true;
     responseParts = responseValue?.split(',').map((part) => part.trim());
    } else {
     responseParts = [responseValue?.trim()];
    }

    let options = questionOptions?.filter((option) =>
     responseParts.includes(option.description.trim())
    );

    if (options.length === 0 && canBeOld) {
     options = questionOptions?.filter((option) =>
      responseValue?.includes(option.description)
     );
    }

    return options;
   }
   return [];
  }, [response, type, questionOptions]);

  return (
   <Stack
    spacing={['16px', '24px']}
    p='6'
    pb='26px'
    bg='white'
    borderRadius='12px'
    my='16px'
    border='2px solid #EAEEF0'
    pos='relative'
   >
    <Flex
     height='44px'
     align='center'
     gap='14px'
     pos='absolute'
     top={['12px', '6']}
     right='6'
    >
     <FeedbackChatReviewerPopover
      question={question}
      response={response}
      idSurvey={surveyId}
      currentAdminRole={1}
      type=''
     />
     <CustomCheckbox
      status={response?.status?.toLowerCase() || 'pending'}
      idQuestionResponse={response?.id_question_response}
      mutate={mutate}
     />
    </Flex>

    <Box maxW='76%'>
     <Text
      as='span'
      color='orange.100'
      fontSize='12px'
      lineHeight='24px'
      fontWeight={500}
     >
      Pergunta obrigatória*
     </Text>

     <Text lineHeight='32px' mt='4px'>
      <b>{code}</b> -{' '}
      <Text
       as='span'
       fontWeight={500}
       dangerouslySetInnerHTML={{ __html: description }}
      />
     </Text>

     {/* GRI-08: "Pilar > Tema" também para quem revisa. Fica FORA do <Text>
         acima de propósito: aquele nó usa dangerouslySetInnerHTML e não aceita
         filhos. */}
     <RotuloClassificacao
      idPillar={question?.id_pillar}
      idTheme={question?.id_theme}
      pillarName={question?.pillar_name}
      themeTitle={question?.theme_title}
      ocultarVazio
     />
    </Box>

    {helper && (
     <QuestionHelper
      description={helper?.description || ''}
      videoUrl={helper?.url_video}
     />
    )}

    {!response && (
     <Text fontSize='sm' fontWeight={500} color='#EA582B' lineHeight='16.44px'>
      Pergunta ainda não respondida
     </Text>
    )}

    {response && (
     <Box>
      {type === 'text' && (
       <InputText defaultValue={response?.response} readOnly w='411px' />
      )}

      {type === 'multi_choice' && (
       <RadioGroup defaultValue={selectedOptions[0]?.description || ''}>
        <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
         {questionOptions?.map(
          (option, i) =>
           option?.description && (
            <Radio key={i} value={option?.description} isReadOnly>
             {option.description}
            </Radio>
           )
         )}
        </Flex>
       </RadioGroup>
      )}

      {type === 'multiple_choice' && (
       <Flex gap='12px' flexWrap='wrap' className='questionary-app'>
        {questionOptions?.map(
         (option, i) =>
          option?.description && (
           <Checkbox
            key={i}
            value={option?.description}
            isChecked={selectedOptions.some(
             (selected) => selected.description === option.description
            )}
            isReadOnly
            className='questionary-checkbox'
           >
            {option.description}
           </Checkbox>
          )
        )}
       </Flex>
      )}

      {type === 'number' && (
       <InputText defaultValue={response?.response} type='number' readOnly w='411px' />
      )}

      {type === 'money' && (
       <NumericFormat
        value={response?.response}
        displayType='input'
        thousandSeparator=','
        decimalSeparator='.'
        prefix='R$ '
        decimalScale={3}
        className='money_input'
       />
      )}

      {type === 'percentage' && (
       <NumericFormat
        value={response?.response}
        suffix='%'
        displayType='input'
        maxLength={4}
        fixedDecimalScale
        className='number_input'
       />
      )}

      {/* GRI-07: o revisor é justamente quem precisa conferir o número que vai
          para o gráfico — e ele não é mais a resposta da questão, é uma medida
          por indicador. Sem isto, só abrindo o banco. */}
      <MedidasGri gri={question?.gri} valores={response?.gri_values} />

      {response?.response_file?.length > 0 && (
       <Button
        variant='secondary'
        fontSize='15px'
        width='224px'
        height='49px'
        mt='20px'
        color='#0073BB'
        onClick={() => handleQuestionEvidence(question?.id_question, response)}
       >
        Vizualizar evidências
       </Button>
      )}
     </Box>
    )}
   </Stack>
  );
 }
);

export default QuestionCardReviewer;
